<template>
  <el-card class="box-card">
    <div slot="header" class="unit-header">
      <div class="unit-header__title">
        {{ $t("cadastro-unidade") }}
        <span class="unit-header__meta">
          <span class="unit-header__count">{{ filtered.length }}</span>
          <template v-if="filtered.length !== tableData.length"> de {{ tableData.length }}</template>
          registros
        </span>
      </div>
      <!-- Busca e situação na linha do título, junto do botão de nova unidade -->
      <div class="unit-header__tools">
        <el-input
          v-model="filter"
          size="mini"
          :placeholder="$t('pesquisar') + ' por código, nome ou sigla'"
          prefix-icon="el-icon-search"
          clearable
          class="unit-filter-search"
        ></el-input>
        <el-radio-group v-model="status" size="mini">
          <el-radio-button label="all" style="padding-bottom: 0px;">Todas</el-radio-button>
          <el-radio-button label="active" style="padding-bottom: 0px;">Ativas</el-radio-button>
          <el-radio-button label="inactive" style="padding-bottom: 0px;">Inativas</el-radio-button>
        </el-radio-group>
        <el-button size="mini" icon="el-icon-plus" type="primary" @click="openNew">Nova unidade</el-button>
      </div>
    </div>

    <UnitEditDialog
      v-if="editor.open"
      :dialog="editor.open"
      :id="editor.id"
      :units="tableData"
      @close="closeEditor"
      @saved="fetchRecords"
    />

    <el-table
      :data="filtered"
      stripe
      size="mini"
      class="unit-table"
      style="width: 100%"
      empty-text="Nenhuma unidade encontrada"
      :default-sort="{ prop: 'name', order: 'ascending' }"
      @row-dblclick="openRow"
    >
      <el-table-column sortable prop="code" :label="$t('codigo')" width="120"></el-table-column>
      <el-table-column sortable prop="name" :label="$t('nome')" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column sortable prop="acronym" :label="$t('sigla')" width="100">
        <template slot-scope="scope">
          <span class="unit-acronym">{{ scope.row.acronym }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="sourceRootStart" :label="$t('faixa-cep')" width="220">
        <template slot-scope="scope">
          <span class="unit-range">{{ unitRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="viewAcronym" label="+Econômico" width="130" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.viewAcronym" class="el-icon-check unit-check" title="Atende Malha +Econômico"></i>
        </template>
      </el-table-column>
      <el-table-column sortable prop="active" :label="$t('ativo')" width="110">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.active ? '' : 'info'" class="unit-status-tag" disable-transitions>
            {{ scope.row.active ? "Ativa" : "Inativa" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="#" width="80" fixed="right">
        <template slot-scope="scope">
          <div class="unit-actions">
            <span class="unit-action-slot">
              <i class="el-icon-edit-outline unit-action-icon" title="Editar unidade" @click="openEdit(scope.row)"></i>
            </span>
            <span class="unit-action-slot">
              <i class="el-icon-delete unit-action-icon" title="Excluir unidade"
                @click="remove(scope.row.id, scope.row.name)"></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
import { UnitService } from "@/services/users/unit.services";
import { i18n } from "@/plugin/i18n";
import UnitEditDialog from "./components/UnitEditDialog.vue";

const CONTROLES = "button, a, input, label, i, .el-checkbox, .el-link, .el-tag";

export default {
  name: "UnitList",
  components: {
    UnitEditDialog,
  },
  data() {
    return {
      filter: "",
      status: "all",
      tableData: [],
      editor: { open: false, id: "" },
    };
  },
  computed: {
    filtered() {
      const term = this.filter.trim().toLowerCase();
      return this.tableData.filter((unit) => {
        if (this.status === "active" && !unit.active) return false;
        if (this.status === "inactive" && unit.active) return false;
        if (!term) return true;
        return [unit.name, unit.code, unit.acronym].some(
          (value) => String(value || "").toLowerCase().includes(term)
        );
      });
    },
  },
  methods: {
    unitRange(unit) {
      const cep = (root, digit) =>
        `${String(root || 0).padStart(5, "0")}-${String(digit || 0).padStart(3, "0")}`;
      return `${cep(unit.sourceRootStart, unit.sourceDigitStart)} à ${cep(
        unit.destinyRootStart,
        unit.destinyDigitStart
      )}`;
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UnitService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    openNew() {
      this.editor = { open: true, id: "" };
    },
    openEdit(row) {
      this.editor = { open: true, id: row.id };
    },
    openRow(row, column, event) {
      const alvo = event && event.target;
      if (alvo && alvo.closest && alvo.closest(CONTROLES)) return;
      if (window.getSelection) window.getSelection().removeAllRanges();
      this.openEdit(row);
    },
    closeEditor() {
      this.editor = { open: false, id: "" };
    },
    remove(id, name) {
      const vm = this;
      vm.$confirm(
        i18n.t("confirmar-eliminacao-unidade", { user: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        UnitService.delete(id)
          .then(() => {
            vm.fetchRecords();
            vm.$message({
              type: "success",
              message: i18n.tc("unidade-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    this.fetchRecords();
  },
};
</script>
<style scoped>
.unit-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.unit-header__title {
  white-space: nowrap;
}

.unit-header__meta {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

.unit-header__count {
  font-weight: 600;
  color: #303133;
}

.unit-header__tools {
  margin-left: auto;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
}

.unit-header__tools > * {
  flex: none;
}

.unit-filter-search {
  width: 260px;
  max-width: 100%;
}

.unit-header__tools >>> .el-radio-group {
  display: inline-flex;
  align-items: center;
  height: 28px;
}

.unit-header__tools >>> .el-radio-button__inner {
  line-height: 1;
  vertical-align: middle;
}

.unit-header__tools >>> .el-radio-button {
  margin-bottom: 0;
}

.unit-table >>> th .cell {
  white-space: nowrap;
}

.unit-acronym {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.unit-range {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.unit-check {
  color: #606266;
  vertical-align: middle;
}

.unit-status-tag {
  display: inline-block;
  width: 64px;
  padding: 0;
  text-align: center;
}

.unit-actions {
  display: flex;
  align-items: center;
  justify-content: end;
}

.unit-action-slot {
  display: inline-flex;
  width: 24px;
  justify-content: center;
}

.unit-action-icon {
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  vertical-align: middle;
  transition: opacity 0.15s ease;
}

.unit-action-icon:hover {
  opacity: 0.65;
}
</style>